import { useEffect, useReducer, useState } from 'react';
import { useNavigate } from 'react-router-dom'; 
import Footer from '../../components/common/footer';
import TablePatter from '../../screens/table';
import Resultados from '../../screens/resultados/resultados';
import Header from '../../components/common/header';

const linkIcon = '/icons/link.svg';
const downLoad = '/icons/downLoad.svg';

const initialState = {
  resData: [],
  carregando: true,
  invert: false,
  isRefresh: false,
  hideChart: true,
  loadTable: true,
  inicio: true,
  params: {
      fy: 0,
      OX: 0.1,
      F: 0.5,
      MCF: 1,
      kji: 1,
      gravimetria: {
          alimentos: 0.453,
          papel: 0.104,
          texteis: 0.056,
          madeira: 0.014,
          jardins: 0.141,
          outros: 0.232
      }
  },
  relatorio: false
};

function reducer(state, action) {
  switch (action.type) {
      case 'RES_DATA':
          return { ...state, resData: action.payload, carregando: false };
      case 'PROJECAO':
          return { ...state, projecao: action.payload, carregando: false };
      case 'TOGGLE_INVERT':
          return { ...state, invert: !state.invert };
      case 'TOGGLE_HIDE_CHART':
          return { ...state, hideChart: !state.hideChart };
      case 'SET_INICIO':
          return { ...state, inicio: action.payload };
      case 'SET_PARAMS':
          return { ...state, params: action.payload };
      case 'TOGGLE_RELATORIO':
            return { ...state, relatorio: !state.relatorio };
      default:
          return state;
  }
}

export function EstimaGas() {
  const navigate = useNavigate(); 
  const [estimagasState, estimagasDispatch] = useReducer(reducer, initialState);
  const [isInverted, setIsInverted] = useState(false);

  const toggleInvert = () => {
    setIsInverted(!isInverted);
  };

  const handleKeyPress = (event, action) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      action();
    }
  };

  function dataFetch() {
    try {
        fetch('/resData.json')
            .then(response => response.json())
            .then(jsonData => {
                estimagasDispatch({ type: 'RES_DATA', payload: jsonData });
            })
            .catch(error => console.error("Erro na chamada fetch:", error));
    } catch (error) {
        console.error("Erro na chamada fetch:", error);
    }
  }

  function defaultParams() {
    let localParams = estimagasState.params;
    if (!localParams || Object.values(localParams).length === 0) {
      estimagasDispatch({ type: 'SET_PARAMS', payload: initialState.params });
    }
  }

  return (
    <div 
      className={`flex flex-col min-h-screen w-full estimagas ${isInverted ? 'inverted' : ''}`}
      role="application"
      aria-label="EstimaGas - Calculadora de Emissões"
    >
      <Header isInverted={isInverted} toggleInvert={toggleInvert} size={14}/>
      <main className="flex-grow" role="main">
          {estimagasState.inicio ? (
            <nav className='absolute flex flex-row z-10 gap-2 p-5 top-20' role="navigation" aria-label="Navegação principal">
              <button 
                className="w-20 cursor-pointer flex[2] text-blue-500 bg-stone-100 border border-blue-700 hover:bg-stone-5 hover:border-blue-900"
                onClick={() => navigate('/')}
                aria-label="Voltar para a página inicial"
              >
                home
              </button> 
              <div 
                className="cursor-pointer w-10" 
                onClick={() => navigate('/')}
                onKeyPress={(e) => handleKeyPress(e, () => navigate('/'))}
                role="button"
                tabIndex="0"
                aria-label="Voltar para a página inicial"
              >
                <img className="w-10" src={linkIcon} alt='Ícone de seta para voltar à página inicial' aria-hidden="true" />
              </div>
            </nav>
          ) : (
            <nav className='absolute flex flex-row z-10 gap-2 p-5 top-20' role="navigation" aria-label="Navegação principal">
              <button 
                className="w-20 cursor-pointer flex[2] text-blue-500 bg-stone-100 border border-blue-700 hover:bg-stone-5 hover:border-blue-900"
                onClick={() => estimagasDispatch({ type: 'SET_INICIO', payload: true })}
                aria-label="Voltar para a tabela de dados"
              >
                Tabela
              </button> 
              <div 
                className="cursor-pointer w-10" 
                onClick={() => estimagasDispatch({ type: 'SET_INICIO', payload: true })}
                onKeyPress={(e) => handleKeyPress(e, () => estimagasDispatch({ type: 'SET_INICIO', payload: true }))}
                role="button"
                tabIndex="0"
                aria-label="Voltar para a tabela de dados"
              >
                <img className="w-10" src={linkIcon} alt='Ícone de seta para voltar à tabela' aria-hidden="true" />
              </div>
            </nav>
          )}
          {estimagasState.resData?.length !== 0 ? 
          (estimagasState.inicio ? 
              <div className="absolute flex flex-row z-10 gap-2 end-4 top-20">
                <button 
                  className="cursor-pointer flex[2] text-blue-500 bg-stone-100 border border-blue-700 hover:bg-stone-5 hover:border-blue-900" 
                  id='resultado-btn-total' 
                  onClick={() => estimagasDispatch({ type: 'SET_INICIO', payload: false })}
                  aria-label="Ver resultados da análise"
                >
                  Resultados
                </button>
                <div 
                  className="cursor-pointer bg-stone-100 w-10" 
                  onClick={() => estimagasDispatch({ type: 'SET_INICIO', payload: false })}
                  onKeyPress={(e) => handleKeyPress(e, () => estimagasDispatch({ type: 'SET_INICIO', payload: false }))}
                  role="button"
                  tabIndex="0"
                  aria-label="Ver resultados da análise"
                >
                  <img className="w-10" src={linkIcon} alt='Ícone de seta para ver resultados' aria-hidden="true" />
                </div>
              </div>
          :
          <div className="absolute flex flex-row z-10 gap-2 end-4 top-20">
            <button 
              className="cursor-pointer flex[2] text-blue-500 bg-stone-100 border border-blue-700 hover:bg-stone-5 hover:border-blue-900" 
              id='resultado-btn-total' 
              onClick={() => estimagasDispatch({ type: 'TOGGLE_RELATORIO' })}
              aria-label="Exportar resultados da análise"
            >
              Exportar resultados
            </button>
            <div 
              className="cursor-pointer bg-stone-100 w-10" 
              onClick={() => estimagasDispatch({ type: 'TOGGLE_RELATORIO' })}
              onKeyPress={(e) => handleKeyPress(e, () => estimagasDispatch({ type: 'TOGGLE_RELATORIO' }))}
              role="button"
              tabIndex="0"
              aria-label="Exportar resultados da análise"
            >
              <img className="w-10" src={downLoad} alt='Ícone de download para exportar resultados' aria-hidden="true" />
            </div>
          </div>
          ): (null)}
    
        {estimagasState.inicio ? (
          <TablePatter 
            estimagasState={estimagasState}
            estimagasDispatch={estimagasDispatch}
            defaultParams={defaultParams}
            dataFetch={dataFetch}
          />
        ) : (
          <Resultados 
            estimagasState={estimagasState}
            estimagasDispatch={estimagasDispatch}
            defaultParams={defaultParams}
            dataFetch={dataFetch}
          />
        )}
      </main>
      <Footer />
    </div>
  );
}
